import { render, staticRenderFns } from "./AdminLab.vue?vue&type=template&id=6be2263c&scoped=true&"
import script from "./AdminLab.vue?vue&type=script&lang=js&"
export * from "./AdminLab.vue?vue&type=script&lang=js&"
import style0 from "./AdminLab.vue?vue&type=style&index=0&id=6be2263c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be2263c",
  null
  
)

export default component.exports